import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'checkbox',
  props: {
  modelValue: {
    type: Boolean
  }
},
  emits: {
  "update:modelValue": Boolean
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["checkbox", {
      checkbox_checked: __props.modelValue
    }]),
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !__props.modelValue)))
  }, null, 2))
}
}

})